import { CultureInfo } from '../culture-info.model';
import { CultureInfoZhHans } from './zh-Hans';

/**
 * @ignore
 */
export const CultureInfoZhHansHK: CultureInfo = {
  name: 'zh-Hans-HK',
  displayName: '简体中文（香港）',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh-Hans-HK',
  parent: CultureInfoZhHans
};
